export const DEFAULT_IMAGE_LINK = 'https://vk.com/images/camera_50.png';
